<template>
  <!-- <el-dialog
    v-model="formVisible"
    title="编辑"
    @close="close"
    width="40%"> -->
  <!-- <h3>基本信息</h3> -->
  <el-form
    :disabled="status === 3"
    ref="ruleFormRef"
    :model="ruleForm"
    :rules="rules"
    label-width="120px"
    class="userForm"
  >
    <div style="text-align: center">
      <el-upload
        :action="'/api/hz-smart-community/sys/file/upload'"
        list-type="picture-card"
        :headers="{
          token: token,
        }"
        :show-file-list="false"
        :on-success="handlePictureCardPreview"
        :limit="1"
        v-if="formVisible"
      >
        <el-icon v-if="!ruleForm.imageUrl"><plus /></el-icon>
        <img v-else :src="imgURL + ruleForm.imageUrl" />
      </el-upload>
    </div>
    <div class="formTitle"><span></span>基本信息</div>
    <el-row>
      <el-col :span="12">
        <el-form-item label="单位名称" prop="unitName">
          <el-input
            v-model="ruleForm.unitName"
            placeholder="单位名称"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="单位类别" prop="unitType">
          <h-selectcode
            type="unitType"
            v-model="ruleForm.unitType"
            placeholder="单位类别"
          ></h-selectcode>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="重点单位" prop="keyunit">
          <el-radio v-model="ruleForm.keyunit" label="1" size="large">
            非重点单位
          </el-radio>
          <el-radio v-model="ruleForm.keyunit" label="0" size="large">
            重点单位
          </el-radio>
          <!-- <el-input
            v-model="ruleForm.keyunit"
            placeholder="重点单位"
          ></el-input> -->
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="经济类型" prop="economicType">
          <h-selectcode
            type="economicType"
            v-model="ruleForm.economicType"
            placeholder="经济类型"
          ></h-selectcode>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="行业类别" prop="industryType">
          <h-selectcode
            type="industry_type"
            v-model="ruleForm.industryType"
            placeholder="行业类别"
          ></h-selectcode>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="上级名称" prop="higherName">
          <el-input
            v-model="ruleForm.higherName"
            placeholder="请输入上级主管单位名称"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="注册资金" prop="registerMoney">
          <el-input
            v-model="ruleForm.registerMoney"
            placeholder="注册资金"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系电话" prop="unitTelphone">
          <el-input
            v-model="ruleForm.unitTelphone"
            placeholder="联系电话"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="网址" prop="url">
          <el-input v-model="ruleForm.url" placeholder="网址"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <div class="formTitle"><span></span>注册地址</div>
    <el-row>
      <!-- <el-col :span="12">
        <el-form-item label="地区" prop="registeredAddress">
          <el-cascader
            v-model="ruleForm.registeredAddress"
            placeholder="重庆市/市辖区/开州区"
            disabled
            clearable
          />
        </el-form-item>
      </el-col> -->
      <el-col :span="12">
        <el-form-item label="地区" prop="registeredAddress">
          <el-cascader
            style="width: 100%"
            v-model="ruleForm.registeredAddress"
            :options="houseRentTypeList"
            placeholder="详细地址"
            clearable
            :props="{ value: 'districtId', label: 'name' }"
          ></el-cascader>
          <!-- <el-input
            v-model="ruleForm.registeredAddressInfo"
            placeholder="详细地址"
          ></el-input> -->
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="详细地址" prop="">
          <el-input
            v-model="ruleForm.registeredAddressInfo"
            placeholder="详细地址"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <div class="formTitle"><span></span>单位地址</div>
    <el-row>
      <el-col :span="24">
        <el-form-item label="详细地址" prop="houseId">
          <el-cascader
            style="width: 100%"
            :props="{
              value: 'id',
              label: 'name',
            }"
            :options="options"
            v-model="ruleForm.houseId"
            placeholder="详细地址"
            clearable
            @change="cascaderchange"
          >
          </el-cascader>
        </el-form-item>
      </el-col>
    </el-row>
    <div class="formTitle" id="one3"><span></span>经营信息</div>
    <el-row>
      <el-col :span="12">
        <el-form-item label="经营名称" prop="businessName">
          <el-input
            v-model="ruleForm.businessName"
            placeholder="经营名称"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="英文名称" prop="unitEnglishName">
          <el-input
            v-model="ruleForm.unitEnglishName"
            placeholder="英文名称"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="英文缩写" prop="englishAbbreviation">
          <el-input
            v-model="ruleForm.englishAbbreviation"
            placeholder="英文缩写"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="开业日期" prop="startdate">
          <el-date-picker
            v-model="ruleForm.startdate"
            type="date"
            placeholder="开业日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="停业日期" prop="enddate">
          <el-date-picker
            v-model="ruleForm.enddate"
            type="date"
            placeholder="停业日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="经应面积" prop="operatingArea">
          <el-input
            v-model="ruleForm.operatingArea"
            placeholder="经应面积"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="经营性质" prop="businessPractice">
          <h-selectcode
            type="business_type"
            v-model="ruleForm.businessPractice"
            placeholder="经营性质"
          ></h-selectcode>
        </el-form-item>
      </el-col>
    </el-row>
    <div class="formTitle"><span></span>经应范围</div>
    <el-row>
      <el-col :span="12">
        <el-form-item label="主营" prop="businessScope">
          <el-input
            v-model="ruleForm.businessScope"
            placeholder="主营"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="兼营" prop="businessSideline">
          <el-input
            v-model="ruleForm.businessSideline"
            placeholder="兼营"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <div class="formTitle"><span></span>经营执照</div>
    <el-row>
      <el-col :span="12">
        <el-form-item label="起始日期" prop="licenseStartdate">
          <el-date-picker
            v-model="ruleForm.licenseStartdate"
            type="date"
            placeholder="起始日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="截止日期" prop="licenseEnddate">
          <el-date-picker
            v-model="ruleForm.licenseEnddate"
            type="date"
            placeholder="截止日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <div class="formTitle" id="one6"><span></span>法定代表人</div>
    <el-row>
      <el-col :span="12">
        <el-form-item label="姓名" prop="legalName">
          <el-input v-model="ruleForm.legalName" placeholder="姓名"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="外文姓" prop="englishSurname">
          <el-input
            v-model="ruleForm.englishSurname"
            placeholder="外文姓"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="外文名" prop="englishName">
          <el-input
            v-model="ruleForm.englishName"
            placeholder="外文名"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="证件种类" prop="legalCardType">
          <h-selectcode
            type="card_type"
            v-model="ruleForm.legalCardType"
            placeholder="证件种类"
          ></h-selectcode>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="证件号码" prop="legalCardNum">
          <el-input
            v-model="ruleForm.legalCardNum"
            placeholder="证件号码"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系电话" prop="legalTelphone">
          <el-input
            v-model="ruleForm.legalTelphone"
            placeholder="联系电话"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <div class="formTitle" id="one7"><span></span>保卫负责人</div>
    <el-row>
      <el-col :span="12">
        <el-form-item label="姓名" prop="mainName">
          <el-input v-model="ruleForm.mainName" placeholder="姓名"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="身份证号" prop="mainCardNum">
          <el-input
            v-model="ruleForm.mainCardNum"
            placeholder="身份证号"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item label="联系电话" prop="mainTelphone">
          <el-input
            v-model="ruleForm.mainTelphone"
            placeholder="联系电话"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <el-divider />
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  ref,
  watch,
} from "vue";
import util from "@util/js";
import { ElMessage } from "element-plus";
import { Plus } from "@element-plus/icons-vue";
import { unitupdate, unitsave, infoQuery } from "@/api/management/management";
import { infoSelect } from "@/api/constant";
import { areaselectList } from "@/api/realPopulation/realPopulation";
import _ from "lodash";
export default defineComponent({
  name: "",
  components: { Plus },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    addSelelctPerson: {
      type: Object,
      default: () => [],
    },
    status: {
      type: Number,
      default: 1, // 1 添加；2 编辑；3 只读
    },
  },
  emits: ["update:modelValue", "submit", "initUnit"],
  setup(props, context) {
    const ruleFormRef = ref(null);
    // const validate = new Validate(ruleFormRef.value);
    const state = reactive({
      token: localStorage.getItem("token"),
      imgURL: window.imgURL,
      defaultPassword: "kzga110",
      formVisible: false,
      passwordType: 1,
      houseRentTypeList: [],
      ruleForm: {
        imageUrl: "",
        unitName: "", //  单位名称
        unitType: "", //  单位类别
        keyunit: "1", //  重点单位
        economicType: "", //  经济类型
        industryType: "", // 行业类别
        higherName: "", // 上级名称
        registerMoney: "", // 注册资金
        unitTelphone: "", // 联系电话
        url: "", //  网址
        registeredAddress: 500154, // 地址
        registeredAddressInfo: "", // '[500000, 500100, 500154]', // 详细地址
        unitAddress: "", // 地区
        houseId: "", // 详细地址
        businessName: "", // 经营名称
        unitEnglishName: "", // 英文名称
        englishAbbreviation: "", // 英文缩写
        startdate: "", // 开业日期
        enddate: "", // 停业日期
        operatingArea: "", // 经营面积
        businessPractice: "", // 经营性质
        businessScope: "", // 经营范围主营
        businessSideline: "", // 经营范围兼营
        licenseStartdate: "", // 起始日期
        licenseEnddate: "", // 截止日期
        legalName: "", // 姓名
        englishSurname: "", // 外文姓
        englishName: "", // 外文名
        legalCardType: "", // 证件种类
        legalCardNum: "", // 证件号码
        legalTelphone: "", // 联系 电话
      },
      ruleFormBack: {},
      rules: {
        unitName: [
          {
            required: true,
            message: "请输入单位名称",
            trigger: "blur",
          },
        ],
        unitType: [
          {
            required: true,
            message: "请选择单位类别",
            trigger: "blur",
          },
        ],
        keyunit: [
          {
            required: true,
            message: "请选择单位",
            trigger: "blur",
          },
        ],
        industryType: [
          {
            required: true,
            message: "请选择行业类别",
            trigger: "blur",
          },
        ],
        registeredAddress: [
          {
            required: true,
            message: "请选择地区",
            trigger: "blur",
          },
        ],
        registeredAddressInfo: [
          {
            required: true,
            message: "请选择详细地址",
            trigger: "blur",
          },
        ],
        unitAddress: [
          {
            required: true,
            message: "请选择地区",
            trigger: "blur",
          },
        ],
        houseId: [
          {
            required: true,
            message: "请选择详细地址",
            trigger: "blur",
          },
        ],
      },
      options: [],
      unitNameoptionsNode: [],
    });
    state.ruleFormBack = _.cloneDeep(state.ruleForm);
    const refData = toRefs(state);
    const infoSelectAxios = async () => {
      const params = {
        type: 0,
      };
      const res = await infoSelect(params);
      const rootPid = res.top.map((item) => {
        return item.toString();
      });
      const options = { pid: "parentId", id: "id", rootPid };
      const treeData = util.arrayToTree(res.list, options);
      state.unitNameoptionsNode = res.list;
      state.options = treeData;
    };
    infoSelectAxios();
    // 地址
    const regist = async () => {
      const res = await areaselectList();
      const newlist = res.districtList;
      const options = { pid: "parentId", id: "districtId", rootPid: 100000 };
      state.houseRentTypeList = util.arrayToTree(newlist, options); // 数组,参数
    };
    regist();
    // 初始化表单
    const initForm = async () => {
      if (props.status !== 1) {
        state.passwordType = 2;
      }
      if (props.status === 2 || props.status === 3) {
        const res = await infoQuery(props.form.unitId);
        const form = { ...state.ruleForm, ...res.syUnitInfo };
        form.houseId = res.syUnitInfo.houseId.toString();
        form.registeredAddress = Number(res.syUnitInfo.registeredAddress);
        // form.registeredAddressInfo = "010101";
        state.ruleForm = _.cloneDeep(form);
        context.emit("initUnit", state.ruleForm);
      } else {
        ruleFormRef.value && ruleFormRef.value.resetFields();
      }
    };
    // 监听
    watch(
      () => state.formVisible,
      (v) => {
        initForm();
      }
    );
    // 监听弹框显示因此
    watchEffect(() => {
      state.formVisible = props.modelValue;
    });
    watchEffect(() => {
      context.emit("update:modelValue", state.formVisible);
    });

    // 保存表单数据
    const submitunilone = () => {
      ruleFormRef.value.validate(async (valid) => {
        if (valid) {
          const form = _.cloneDeep(state.ruleForm);
          form.deptId = props.form.parentId;
          form.prisonInfoIdList = props.addSelelctPerson.map((item) => {
            return item.prisonId;
          });
          util.formatForm(form);
          const arr = [
            "legalTelphone",
            "legalCardNum",
            "unitTelphone",
            "mainTelphone",
          ];
          util.formatFormNumber(form, arr); //删除号码中带  * 的
          console.log(form);
          let res;
          if (props.status === 1) {
            res = await unitsave(form);
          } else if (props.status === 2) {
            res = await unitupdate(form);
          }
          if (res.code === 0) {
            state.formVisible = false;
            ElMessage.success("操作成功");
            context.emit("cancel");
            context.emit("saveSuccess");
          }
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };
    const close = () => {
      state.ruleForm = _.cloneDeep(state.ruleFormBack);
    };
    const handlePictureCardPreview = (file) => {
      state.ruleForm.imageUrl = file.data.fileUrl;
    };
    // 详细地址的判断
    const cascaderchange = (val) => {
      const value = val[val.length - 1];
      console.log(val, 6666);
      state.unitNameoptionsNode.forEach((item) => {
        if (item.id === value) {
          if (item.type === 7) {
            console.log(item);
            state.ruleForm.houseId = item.id;
          } else {
            state.ruleForm.houseId = [];
            ElMessage({
              type: "warning",
              message: "请具体选择到房屋",
            });
          }
        }
      });
    };
    return {
      ...refData,
      submitunilone,
      close,
      handlePictureCardPreview,
      ruleFormRef,
      cascaderchange,
    };
  },
});
</script>
<style lang="scss" scoped>
.userForm {
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
  }
  :deep(.el-upload--picture-card) {
    width: 100px;
    height: 100px;
    font-size: 16px !important;
    .el-icon {
      margin-top: 36px !important;
    }
  }
}
.formTitle {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  span {
    width: 3.5px;
    height: 16px;
    background-color: #5584ff;
    margin-right: 10px;
  }
}
.margLeftLabel {
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>
